import React from "react";

export const TextSmall = ({text,color}) => (
    <span className={`manager-component__text-small ${color}`}>
        {text}
    </span>
);

export default TextSmall;